module.exports = __webpack_public_path__ + "media/images/faces/male/35-c2fe3d1c22bc10a458937f937652bea4.jpg";